























































































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import PageHeader from '../../../components/vui-luma/Ui/PageHeader.vue';
import PageSeparator from '../../../components/vui-luma/Ui/PageSeparator.vue';
import CustomSelectInput from '../../../components/vui-luma/Ui/CustomSelectInput.vue';
import MdIcon from '../../../components/vui-luma/Ui/MdIcon.vue';
import {
  dispatchGetLandingElements,
  dispatchDeleteLandingElement,
  dispatchUpdateLandingElement, dispatchAddLandingElement,
} from '@/store/user_flows/actions';
import {readCanAddElements, readLandingElements} from '@/store/user_flows/getters';
import {elementFields} from './fields';
import {store} from '@/store';
import {ISelectChoices} from '@/interfaces';
import {api} from '@/api';

@Component({
  components: {
    PageHeader,
    PageSeparator,
    MdIcon,
    CustomSelectInput,
  },
})
export default class LandingEdit extends Vue {
  public elementFields = elementFields;
  public options: ISelectChoices = {
    choices: ['', ''],
  };
  public newElement = {
    id: 0,
    position: 10,
    title: '',
    codename: '',
    landing_type: 'text',
  };

  public async loadOptions() {
    const response = await api.getSelectChoices(
        '/user_flows/landing_types/choices/', this.$store.getters.token,
    );
    if (response.data) {
      this.options = response.data;
    }
  }

  public async created() {
    await dispatchGetLandingElements(this.$store, { id: this.$router.currentRoute.params.id });
    await this.loadOptions();
    const landingElements = readLandingElements(this.$store);
    const canAddElements = readCanAddElements(this.$store);
  }

  get landingElements() {
    return readLandingElements(this.$store);
  }

  get canAddElements() {
    return readCanAddElements(this.$store);
  }

  public handleSubmit(id = 0) {
    const formDataValidation = {};
    const formData = new FormData();
    let isValid = true;
    let formElements = {};
    if (id === 0) {
      // @ts-ignore
      formElements = this.$refs.newElementForm.elements;
    } else {
      // @ts-ignore
      formElements = window.document.getElementById(`elementForm-${id}`);
    }
    // @ts-ignore
    for (const [key, item] of Object.entries(formElements)) {
      // @ts-ignore
      if (item.name !== undefined && item.name !== '') {
        // @ts-ignore
        if (item.type === 'file') {
          // @ts-ignore
          if (item.files[0] !== undefined) {
          // @ts-ignore
            formData.append(item.name, item.files[0]);
          // @ts-ignore
            formDataValidation[item.name] = item.files[0];
          }
        // @ts-ignore
        } else if (item.type === 'checkbox') {
          // @ts-ignore
          formData.append(item.name, item.checked);
        } else {
          // @ts-ignore
          formData.append(item.name, item.value ? item.value : '');
          // @ts-ignore
          formDataValidation[item.name] = item.value ? item.value : '';
        }
      }
    }
    if (id === 0) {
      // @ts-ignore
      if ((formDataValidation.title === '' || formDataValidation.title === undefined)
          // @ts-ignore
          && (formDataValidation.codename === '' || formDataValidation.codename === undefined)) {
        isValid = false;
      }
    }
    // @ts-ignore
    if (formDataValidation.landing_type === 'text'
      // @ts-ignore
      && (formDataValidation.text === '' || formDataValidation.text === undefined)) {
      isValid = false;
    // @ts-ignore
    } else if (formDataValidation.landing_type === 'string'
      // @ts-ignore
      && (formDataValidation.string === '' || formDataValidation.string === undefined)) {
      isValid = false;
    // @ts-ignore
    } else if (formDataValidation.landing_type === 'video'
      // @ts-ignore
      && (formDataValidation.video_url === '' || formDataValidation.video_url === undefined)) {
      isValid = false;
    // @ts-ignore
    } else if (formDataValidation.landing_type === 'image'
      // @ts-ignore
      && (formDataValidation.image === '' || formDataValidation.image === undefined)) {
      // setTextSnackbar('Поле не может быть пустым');
      isValid = false;
    }
    if (isValid) {
      if (id === 0) {
        dispatchAddLandingElement(
          this.$store,
          { landingId: this.$router.currentRoute.params.id, data: formData },
        );
        this.newElement = {
          id: 0,
          position: 10,
          title: '',
          codename: '',
          landing_type: 'text',
        };
      } else {
        dispatchUpdateLandingElement(
          this.$store,
          { landingId: this.$router.currentRoute.params.id, elementId: id, data: formData },
        );
      }
    // @ts-ignore
      this.showToast(this, this.$t('Save'));
    } else {
    // @ts-ignore
      this.showToast(this, this.$t('Fill all empty fields'), 'error');
    }
  }

  public handleDeleteElement(id) {
    // @ts-ignore
    if ( confirm(this.$t('Delete element?')) ) {
      dispatchDeleteLandingElement(
          this.$store,
          {landingId: this.$router.currentRoute.params.id, elementId: id},
      );
    // @ts-ignore
      this.showToast(this, this.$t('Deleted successfully'));
    }
  }

}
